import configFile from '../../config/config.json';

export interface Config {
  competitionsDefault: ConfigCompetition;
  competitions: ConfigCompetition[];
  connectedCompetition: [string[], string[]];
  regulationLink: string;
}

export interface ConfigCompetition {
  id: string;
  shortName: string;
  name: string;
  description: string;
  matchHeader: string;
  matchHeaderMobile: string;
  logo: string;
  seasonYear: string;
  type: string;
  sex: string;
  displayRounds?: string;
  groupByMonth?: boolean;
  hideMatchUnitDetail?: boolean;
  disableSquadList?: boolean;
  phase?: string;
  newTableSeason?: number;
  splitTablePlaces?: boolean;
  splitConfig?: Record<string, string>;
  procedureUrl?: string;
  procedureUrlText?: string;
}

const config = <Config>configFile;

export default config;
